import React from "react";

interface ProgressBarProps {
  percentage: number;
  completed?: number;
  docNA?: number;
  pending?: number;
  totalDocs?: number;
  totalQA?: number;
  barOnly?: boolean;
  color?: string;
}

const ProgressBar = ({
  percentage,
  completed,
  docNA,
  pending,
  totalDocs,
  totalQA,
  barOnly = false,
  color,
}: ProgressBarProps) => {
  if (barOnly) {
    return (
      <div className="progress-bar-track">
        <div
          className="progress-bar-fill"
          style={{
            width: `${percentage}%`,
            ...(color ? { background: color } : {}),
          }}
        ></div>
      </div>
    );
  }

  return (
    <div className="progress-wrap">
      <div className="progress-header">
        <div className="progress-title">Overall completion</div>
        <div className="progress-pct">{percentage}%</div>
      </div>
      <div className="progress-bar-track">
        <div
          className="progress-bar-fill"
          style={{ width: `${percentage}%` }}
        ></div>
      </div>
      <div className="progress-counts">
        <div className="pc-count">
          <div
            className="pc-count-dot"
            style={{ background: "var(--green)" }}
          ></div>
          <span>{completed}</span> completed
        </div>
        <div className="pc-count">
          <div
            className="pc-count-dot"
            style={{ background: "var(--tx3)" }}
          ></div>
          <span>{docNA}</span> N/A
        </div>
        <div className="pc-count">
          <div
            className="pc-count-dot"
            style={{ background: "var(--abd)" }}
          ></div>
          <span>{pending}</span> pending
        </div>
      </div>
    </div>
  );
};

export default ProgressBar;
